import { render } from "./RedaccionesComponent.vue?vue&type=template&id=de7a1be2&scoped=true"
import script from "./RedaccionesComponent.vue?vue&type=script&lang=js"
export * from "./RedaccionesComponent.vue?vue&type=script&lang=js"

import "./RedaccionesComponent.vue?vue&type=style&index=0&id=de7a1be2&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7a1be2"]])

export default __exports__